import { useRef, RefObject } from "react";
import { useVideoConfig, OffthreadVideo, Audio } from "remotion";
import { VideoSegmentMultiFocusDesignSystemConfig } from "../../VideoSegmentMultiFocus";
import { onVideoFrame } from "../DefaultVideoSegmentMultiFocus";
import { BorderWrapper } from "../utils/borderStyle";

const SquareFocus: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = ({ startTimestampMS, endTimestampMS, videoURL, spacing, borderRadius, border, borderStyle, framing, designSystem, audioURL }) => {
    const { width, height, fps } = useVideoConfig();

    // We will display a single 1:1 video
    const canvasRefs = [useRef<HTMLCanvasElement>(null)];

    const paddingSize = spacing ? Math.sqrt(width * height) * 0.05 : 0;
    const borderThickness = spacing ? Math.sqrt(width * height) / 150 : 0;

    const totalSize = Math.min(width, height) - paddingSize * 2 - borderThickness * 2;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                alignContent: 'space-evenly',
                width: '100%',
                height: '100%',
            }}
        >
            <OffthreadVideo
                style={{ opacity: 0, display: 'none' }}
                src={videoURL}
                startFrom={startTimestampMS / 1000 * fps}
                endAt={endTimestampMS / 1000 * fps}
                onVideoFrame={(frame) => onVideoFrame(frame, framing[designSystem.canvas.aspectRatio].focusRegions, canvasRefs as RefObject<HTMLCanvasElement>[])}
                muted={audioURL == undefined ? false : true}
            />
            {audioURL && <Audio src={audioURL} />}
            {framing[designSystem.canvas.aspectRatio].focusRegions.map((_, index) => (
                <BorderWrapper
                    key={index}
                    borderStyle={borderStyle}
                    borderThickness={borderThickness}
                    borderRadius={borderRadius}
                >
                    <canvas
                        ref={canvasRefs[index]}
                        width={totalSize}
                        height={totalSize}
                        style={{
                            aspectRatio: '1 / 1',
                        }}
                    />
                </BorderWrapper>
            ))}
        </div>
    );
}

export const SquareFocusVideoSegment: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = (props) => {
    return (
        <SquareFocus {...props} />
    )
}